<template>
  <Modal>
    <Modal.Body class="overflow-y-auto">
      <ProMembershipDetailsBody desktop />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'

import ProMembershipDetailsBody from './ProMembershipDetailsBody.vue'
</script>
